import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-product-card-skeleton',
  templateUrl: './list-product-card-skeleton.component.html',
  styleUrls: ['./list-product-card-skeleton.component.scss']
})
export class ListProductCardSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
